import { MutableValue } from "../api/mutable-value.interface";

export default class CountryRegion implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fCountry: string,
    private fName: string,
    private fCode: string
  ) {
    [fId, fCountry, fName, fCode].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get country(): string {
    return this.fCountry;
  }

  get code(): string {
    return this.fCode;
  }

  get name(): string {
    return this.fName;
  }
}
